var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { c } from '@debbie/cortex/dist';
import { Button, Input, Header } from '../..';
const PasswordCreator = (props) => {
    const lang = useSelector((s) => s.lang);
    const [password, setPassword] = useState('');
    const valid = password.length >= 8;
    return (React.createElement("div", null,
        React.createElement("form", { onSubmit: (e) => __awaiter(void 0, void 0, void 0, function* () {
                e.preventDefault();
                e.stopPropagation();
                const response = yield c.auth.createPassword(props.token, password);
                if (response != null) {
                    const queryParams = new URLSearchParams(window.location.search);
                    queryParams.delete('nu_token');
                    window.location.search = queryParams.toString();
                }
            }) },
            React.createElement(Header, null, lang.onboarding.welcome),
            React.createElement("p", null, lang.onboarding.passwordCreatorExplainer),
            React.createElement(Input, { type: "password", placeholder: lang.login.password, onChange: (e) => {
                    setPassword(e.target.value);
                }, value: password }),
            React.createElement(Button, { block: true, style: { marginBottom: '10px' }, disabled: !valid }, lang.misc.submit))));
};
export default PasswordCreator;
//# sourceMappingURL=PasswordCreator.js.map